var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Editor',_vm._g(_vm._b({ref:"toastuiEditor",staticClass:"editor",attrs:{"initialEditType":"wysiwyg","options":_vm.editorOptions}},'Editor',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }